import { useContext } from "react";
import { CircleLoader, PageHeader } from "components";
import { Filter, Results } from './components';
import { customersContext } from './CustomersContext';


let WorkLogs = () => {
    let service = useContext(customersContext);


    return (
        <>
            <PageHeader pageTitle={"Clienti"} addNewUrl={`/customer/addnew/`} />
            <Filter />
            {service.isLoading && <CircleLoader />}
            {service.isLoading === false && <Results />}
        </>
    );
}

export default WorkLogs;